import React, { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { EPerformanceEvaluationStatus } from '@common/definitions';

export type BadgeProps = PropsWithChildren<{
  status?: EPerformanceEvaluationStatus;
  text?: string;
}>;

const StatusBadge = ({ status }: BadgeProps) => {
  const { t } = useTranslation();

  const getStatusClasses = (progress?: EPerformanceEvaluationStatus) => {
    const baseClasses =
      'tw-inline-block tw-px-2 tw-py-[6px] tw-text-xs tw-font-normal !tw-rounded-[8px] tw-text-center tw-w-[60px]';

    switch (progress) {
      case EPerformanceEvaluationStatus.STARTED:
        return `${baseClasses} tw-text-gray-custom-500 tw-bg-gray-custom-100`;
      case EPerformanceEvaluationStatus.SUBMITTED:
        return `${baseClasses} tw-text-blue-custom tw-bg-blue-light`;
      case EPerformanceEvaluationStatus.FINISHED:
        return `${baseClasses} tw-text-green-custom tw-bg-green-light`;
      default:
        return `${baseClasses} tw-text-gray-600 tw-bg-gray-100`;
    }
  };

  return (
    <div className={getStatusClasses(status)}>
      {t('performance:status', { context: status })}
    </div>
  );
};

export default StatusBadge;
